<template lang="pug" id="app">
  b-container(fluid)
    b-row
      b-col(cols="12")
        b-card.w-100(no-body)
          div(slot="header")
            b-row
              b-col(cols="4")
                b-form-file(@change="readFile")
              b-button(size="sm" type="button" variant="" @click="onSubmit") {{$t('enrollment')}}
              b-button.ml-4(v-if="lang === 'en'" size="sm", variant="primary", target="_blank", :href="`${Form}/linkmemine_user_form_en.xlsx`", download) {{$t('excel-form')}}
              b-button.ml-4(v-else size="sm", variant="primary", target="_blank", :href="`${Form}/linkmemine_user_form_ko.xlsx`", download) {{$t('excel-form')}}
              
          b-form(@submit="onSubmit")
            table.table(
              :current-page="page.current",
              :per-page="page.per",
              :fields="fields",
              :items="items"
              :empty-text="$t('no-content')"
            )
              thead
                tr
                  th(scope="col") {{$t('enrollment')}}
                  th(scope="col") {{$t('ID')}}
                  th(scope="col") {{$t('PW')}}
                  th(scope="col") {{$t('name')}}
                  th(scope="col") {{$t('Email')}}
                  th(scope="col") {{$t('phone')}}
                  th(scope="col") {{$t('department')}}
                  th(scope="col") {{$t('cowork_position')}}
                  th(scope="col") {{$t('group')}}
              tbody#tbody
          div.d-flex.justify-content-between(slot="footer")
            div
              b-form-select(
                size="sm",
                v-model="page.per",
                :options="page.perOptions")
            b-pagination(
              size="sm",
              :total-rows="page.total",
              :per-page="page.per",
              v-model="page.current",
              class="my-0 float-right"
            )                       
</template>

<script>
import Switches from "vue-switches"
import { UsersAPI, UserExcelUploadAPI } from "../../../api"
import XLSX from "xlsx"
import store from "@/api/store"

export default {
  name: "excel-add-manager-component",
  components: { Switches },
  methods: {
    readFile(event) {
      var input = event.target
      var reader = new FileReader()
      reader.onload = e => {
        var fileData = reader.result
        var wb = XLSX.read(fileData, { type: "binary" })
        wb.SheetNames.forEach(function(sheetName) {
          var rowObj = XLSX.utils.sheet_to_json(wb.Sheets[sheetName], {
            header: 0,
            defval: "",
          })
          var itemList = JSON.stringify(rowObj)
          // validated csv row data -> table
          var obj = JSON.parse(itemList)
          var rowCells = Object.keys(rowObj[0])
          var tbody = "<tbody>"
          for (var singleRow = 0; singleRow < rowObj.length; singleRow++) {
            var singleValue = Object.values(rowObj[singleRow])
            var validId = singleValue[0]
            var validPw = singleValue[1]
            var validName = singleValue[2]
            if (/^[a-zA-Z0-9@._-]{4,38}$/g.test(validId)) {
              if (/^(?=.*?[A-Za-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,12}$/.test(validPw)) {
                if (validName !== "") {
                  for (var rowCell = 0; rowCell < rowCells.length; rowCell++) {
                    if (rowCell === 0) {
                      tbody += '<td><input type="checkbox" name="chkbox" value="added" class="chkbox" checked></td>'
                    }
                    tbody += "<td>"
                    tbody += singleValue[rowCell]
                    tbody += "</td>"
                  }
                  tbody += "</tr>"
                }
              }
            }
          }
          tbody += "</tbody>"
          document.getElementById("tbody").innerHTML = tbody
        })
      }
      reader.readAsBinaryString(input.files[0])
      this.AppState.$emit("show-message-dialog", {
        title: "LinkMeMine",
        context: { path: "excel_onloaded" },
      })
    },
    onSubmit(evt) {
      var allRow = document.getElementById("tbody").rows
      var data = []
      var headers = []

      headers[1] = "mgrid"
      headers[2] = "pw"
      headers[3] = "name"
      headers[4] = "email"
      headers[5] = "phone"
      headers[6] = "department"
      headers[7] = "position"
      headers[8] = "group_name"

      var chk = 0
      var chkbox = document.querySelectorAll(".chkbox")
      for (var i = 0; i < allRow.length; i++) {
        var tableRow = allRow[i]
        var rowData = {}
        for (var j = 1; j < tableRow.cells.length; j++) {
          rowData[headers[j]] = tableRow.cells[j].innerHTML
        }
        if (chkbox[i].checked == true) {
          data.push(rowData)
        }
      }
      var itemList = JSON.stringify(data)
      UserExcelUploadAPI.post("", itemList)
        .then(resp => {
          let total = resp.data.objects.total
          let failure = resp.data.objects.failure
          this.$awn.success(this.$t("excel_user_submit", { total, failure }))
          this.$router.push({ name: "managers" })
        })
        .catch(e => {
          console.log(e)
        })
    },
    getSummary() {
      let stored = store.get("lang")
      this.lang = stored
    },
  },
  mounted() {
    this.getSummary()
  },
  data() {
    return {
      pageMounted: false,
      fields: [],
      items: [],
      page: {
        total: 0,
        current: 1,
        per: 10,
        perOptions: [
          { value: 5, text: "5" },
          { value: 10, text: "10" },
          { value: 15, text: "15" },
          { value: 20, text: "20" },
        ],
      },
      Form: `${this.AppState.Path.download}/form`,
      lang: "",
    }
  },
}
</script>

<style scoped>
th,
td {
  padding-right: 50px;
  text-align: left;
}
table {
  margin: 0 auto;
}
</style>
